import { useState } from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { HiChevronDown } from "react-icons/hi";

interface Option {
  label: string;
  value: string | number;
}

interface Props {
  label?: string;
  error?: FieldError;
  register?: UseFormRegisterReturn;
  height?: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  selectClassName?: string;
  value?: string | number;
  onChange?: (value: string) => void;
  options: Option[];
  id?: string;
}

export function INSelect({
  label,
  error,
  register,
  height = "46px",
  disabled,
  placeholder,
  className,
  selectClassName,
  value,
  onChange,
  options,
  id,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`flex flex-col ${className}`}>
      <label className="w-full">
        {label && (
          <span className="text-sm font-bold text-darkGrey-700">{label}</span>
        )}
        <div className={`relative ${label ? "mt-2" : ""}`}>
          <select
            disabled={disabled}
            id={id}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            className={`custom-select flex w-full appearance-none items-center justify-center rounded-xl border bg-white p-3 text-sm font-medium outline-none disabled:border-none disabled:bg-secondaryGrey-400 ${
              error
                ? "border-error text-error"
                : "border-darkGrey-500 text-darkGrey-700"
            } ${selectClassName}`}
            {...register}
            style={{ height }}
            onFocus={() => setIsOpen(true)}
            onBlur={() => setIsOpen(false)}
          >
            {placeholder && (
              <option value="" disabled hidden className="text-darkGrey-500">
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {/* Custom chevron icon */}
          <div className="pointer-events-none absolute right-3 top-0 flex h-full items-center text-darkGrey-700">
            <HiChevronDown
              size={16}
              className={`text-darkGrey-700 transition-transform duration-200 ${
                isOpen ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
        </div>
      </label>

      {error && error.message && (
        <p className="mt-1 text-sm font-medium text-error">{error.message}</p>
      )}
    </div>
  );
}
